export const UPLOAD_PACKAGES_ENDPOINT = "/procuring_entity_packages/import";
export const UPLOAD_SAFEGUARD_CONCERNS_ENDPOINT = "/safeguard_concerns/import";
export const UPLOAD_SUBPROJECTS_ENDPOINT = "/sub_projects/import";
export const GET_SUBPROJECTS_ENDPOINT = "/sub_projects";
export const PROCURING_ENTITY_REPORTS_ENDPOINT = "/procuring_entity_reports";
export const SAFEGUARD_CONCERS_ENDPOINT = "/safeguard_concerns";
